export default __webpack_public_path__ + "static/media/Shake Hand.b54d84c8.png";